import styled, { css } from 'styled-components';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { NewTabLink } from 'ui/links';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { HeaderColRight } from 'ui/pageHeader/PageHeader.styled';
import { fontSizes } from 'ui/theme';

import { pxToRem } from 'utils/convert';

export const HeaderContentContainer = styled.div`
  align-items: center;
  background: none;
  display: flex;
`;

export const StyledSecondaryPageHeader = styled(SecondaryPageHeader)`
  &&[data-variant=${PAGE_HEADER_VARIANTS.SECONDARY}] {
    align-items: stretch;
  }
  ${HeaderColRight} {
    display: flex;
    align-items: flex-end;
  }
  && {
    @media screen and (max-width: ${pxToRem(893)}) {
      flex-direction: column;
      align-items: start;
    }
  }

  [data-page-header-content] > *:first-child {
    overflow: hidden;
    max-width: ${pxToRem(893)};
  }
`;

const baseLinkStyles = css`
  font-size: ${fontSizes.s12};
  line-height: 1.15em;
  border-bottom: unset;
  text-decoration: underline;
`;

export const CampaignDetailLink = styled(NewTabLink)`
  ${baseLinkStyles}
`;
